import CommonGroundGroup from "./CommonGroundGroup";

function CommonGrounds(props) {
	const cgFor = props.commonGrounds.filter(cg => cg.type === "for");
	const cgAgainst = props.commonGrounds.filter(cg => cg.type === "against");
	const cgBoth = props.commonGrounds.filter(cg => cg.type === "both");

	return (
		<div className="m-4 flex justify-evenly gap-4">
			<CommonGroundGroup
				key="for"
				type="for"
				role={props.role}
				commonGrounds={cgFor}
				updateCommonGroundPriorities={props.updateCommonGroundPriorities}
				openConfirmActionModal={props.openConfirmActionModal}
			/>
			<CommonGroundGroup
				key="against"
				type="against"
				role={props.role}
				commonGrounds={cgAgainst}
				updateCommonGroundPriorities={props.updateCommonGroundPriorities}
				openConfirmActionModal={props.openConfirmActionModal}
			/>
			<CommonGroundGroup
				key="both"
				type="both"
				role={props.role}
				commonGrounds={cgBoth}
				updateCommonGroundPriorities={props.updateCommonGroundPriorities}
				openConfirmActionModal={props.openConfirmActionModal}
			/>
		</div>
	);
}

export default CommonGrounds;
